let prefix = '/api/v1/';

export const PdpApiConstants = {
  OTP_MASHERY: prefix + 'generate-otp',
  OTP_MASHERY1: prefix + 'validate-otp',
  FETCH_CONSENT: prefix + 'fetch-consent',
  UPDATE_CONSENT: prefix + 'update-consent',
  VALIDATE_HASH: prefix + 'validate-hash',
  FETCH_CONSENT_HASH: prefix + 'fetch-consent-5x',
  UPDATE_CONSENT_HASH: prefix + 'update-consent-5x',
};